import useRevisionFileBlob from '../../../../../hooks/api/revisions/useRevisionFileBlob';

/**
 * Hook which will fetch the contents of a revision file match,
 * returned as a UTF-8 string for display in the CodeViewer.
 *
 * The file contents are re-fetched if the file path or revision locator change.
 */
function useRevisionFileBlobForCodemirror(revisionLocator: string, filePath: string) {
  const { data, isFetching, isError, error } = useRevisionFileBlob(revisionLocator, filePath);
  const [, fileContents] = data || [];
  //  If the file is not found, we display a "reanalyze dependency" button.
  const isNotFound = isError && (error as Error)?.message?.includes('Not Found');

  return {
    error,
    isError,
    //  Note that this is slightly different from isLoading from React Query.
    //  isLoading is basically `isFetching || !data`, but we need to stop rendering
    //  the CodeViewer component when re-fetching (so it can highlight stuff),
    //  so instead we use isFetching here.
    isLoading: isFetching,
    isNotFound,
    fileContents,
  };
}

export default useRevisionFileBlobForCodemirror;
